import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftRightIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 400 356",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".arrow-left-right-icon-cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:28px;}" }) }),
		/* @__PURE__ */ _jsx("line", {
			className: "arrow-left-right-icon-cls-1",
			x1: 17.53,
			y1: 178,
			x2: 382.47,
			y2: 178
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "arrow-left-right-icon-cls-1",
			x1: 290.47,
			y1: 86,
			x2: 382.47,
			y2: 178
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "arrow-left-right-icon-cls-1",
			x1: 17.53,
			y1: 178,
			x2: 109.53,
			y2: 270
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "arrow-left-right-icon-cls-1",
			x1: 109.53,
			y1: 86,
			x2: 17.53,
			y2: 178
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "arrow-left-right-icon-cls-1",
			x1: 382.47,
			y1: 178,
			x2: 290.47,
			y2: 270
		})
	]
});
export default SvgArrowLeftRightIcon;
